/**
 * Country calling codes and national number lengths, per ISO 3166-1 alpha-2 region.
 *
 * **Generated, not typed.** Taken once from libphonenumber-js 1.13.14's `max` metadata
 * (`getCountryCallingCode`, `possibleLengths`, `nationalPrefix`) and committed, so the phone
 * picker ships a few kilobytes of data instead of a parsing library the bundle budget cannot
 * afford. Regenerate from the same calls when a country's numbering plan changes; do not edit
 * rows by hand.
 *
 * Each row: `[callingCode, minNationalDigits, maxNationalDigits, nationalPrefix, main?]`.
 *
 * `main` marks the region a shared calling code belongs to when a number carries nothing else:
 * `+1` is read as the United States, `+44` as the United Kingdom, `+7` as Russia. The others
 * sharing that code are still valid, but only when somebody chose them.
 */
export const CALLING_CODES: Readonly<
  Record<string, readonly [string, number, number, string, true?]>
> = {
  AC: ['247', 5, 6, ''],
  AD: ['376', 6, 9, ''],
  AE: ['971', 5, 12, '0'],
  AF: ['93', 9, 9, '0'],
  AG: ['1', 10, 10, '1'],
  AI: ['1', 10, 10, '1'],
  AL: ['355', 6, 9, '0'],
  AM: ['374', 8, 8, '0'],
  AO: ['244', 9, 9, ''],
  AR: ['54', 10, 11, '0'],
  AS: ['1', 10, 10, '1'],
  AT: ['43', 4, 13, '0'],
  AU: ['61', 5, 12, '0', true],
  AW: ['297', 7, 7, ''],
  AX: ['358', 5, 12, '0'],
  AZ: ['994', 9, 9, '0'],
  BA: ['387', 8, 9, '0'],
  BB: ['1', 10, 10, '1'],
  BD: ['880', 6, 10, '0'],
  BE: ['32', 8, 9, '0'],
  BF: ['226', 8, 8, ''],
  BG: ['359', 6, 12, '0'],
  BH: ['973', 8, 8, ''],
  BI: ['257', 8, 8, ''],
  BJ: ['229', 8, 10, ''],
  BL: ['590', 9, 9, '0'],
  BM: ['1', 10, 10, '1'],
  BN: ['673', 7, 7, ''],
  BO: ['591', 8, 9, '0'],
  BQ: ['599', 7, 7, ''],
  BR: ['55', 8, 11, '0'],
  BS: ['1', 10, 10, '1'],
  BT: ['975', 7, 8, ''],
  BW: ['267', 7, 10, ''],
  BY: ['375', 6, 11, '8'],
  BZ: ['501', 7, 11, ''],
  CA: ['1', 7, 10, '1'],
  CC: ['61', 6, 12, '0'],
  CD: ['243', 7, 10, '0'],
  CF: ['236', 8, 8, ''],
  CG: ['242', 9, 9, ''],
  CH: ['41', 9, 12, '0'],
  CI: ['225', 10, 10, ''],
  CK: ['682', 5, 5, ''],
  CL: ['56', 9, 11, ''],
  CM: ['237', 8, 9, ''],
  CN: ['86', 7, 12, '0'],
  CO: ['57', 8, 11, '0'],
  CR: ['506', 8, 10, ''],
  CU: ['53', 6, 10, '0'],
  CV: ['238', 7, 7, ''],
  CW: ['599', 7, 8, '', true],
  CX: ['61', 6, 12, '0'],
  CY: ['357', 8, 8, ''],
  CZ: ['420', 9, 12, ''],
  DE: ['49', 4, 15, '0'],
  DJ: ['253', 8, 8, ''],
  DK: ['45', 8, 8, ''],
  DM: ['1', 10, 10, '1'],
  DO: ['1', 10, 10, '1'],
  DZ: ['213', 8, 9, '0'],
  EC: ['593', 8, 11, '0'],
  EE: ['372', 7, 10, ''],
  EG: ['20', 8, 10, '0'],
  EH: ['212', 9, 9, '0'],
  ER: ['291', 7, 7, '0'],
  ES: ['34', 9, 9, ''],
  ET: ['251', 9, 9, '0'],
  FI: ['358', 5, 12, '0', true],
  FJ: ['679', 7, 11, ''],
  FK: ['500', 5, 5, ''],
  FM: ['691', 7, 7, ''],
  FO: ['298', 6, 6, ''],
  FR: ['33', 9, 9, '0'],
  GA: ['241', 7, 8, ''],
  GB: ['44', 7, 10, '0', true],
  GD: ['1', 10, 10, '1'],
  GE: ['995', 9, 9, '0'],
  GF: ['594', 9, 9, '0'],
  GG: ['44', 7, 10, '0'],
  GH: ['233', 8, 9, '0'],
  GI: ['350', 8, 8, ''],
  GL: ['299', 6, 6, ''],
  GM: ['220', 7, 9, ''],
  GN: ['224', 8, 9, ''],
  GP: ['590', 9, 9, '0', true],
  GQ: ['240', 9, 9, ''],
  GR: ['30', 10, 12, ''],
  GT: ['502', 8, 11, ''],
  GU: ['1', 10, 10, '1'],
  GW: ['245', 7, 9, ''],
  GY: ['592', 7, 7, ''],
  HK: ['852', 5, 11, ''],
  HN: ['504', 8, 11, ''],
  HR: ['385', 7, 9, '0'],
  HT: ['509', 8, 8, ''],
  HU: ['36', 8, 9, '06'],
  ID: ['62', 7, 17, '0'],
  IE: ['353', 7, 10, '0'],
  IL: ['972', 7, 12, '0'],
  IM: ['44', 10, 10, '0'],
  IN: ['91', 8, 13, '0'],
  IO: ['246', 7, 7, ''],
  IQ: ['964', 8, 10, '0'],
  IR: ['98', 4, 10, '0'],
  IS: ['354', 7, 9, ''],
  IT: ['39', 6, 12, '', true],
  JE: ['44', 10, 10, '0'],
  JM: ['1', 10, 10, '1'],
  JO: ['962', 8, 9, '0'],
  JP: ['81', 8, 17, '0'],
  KE: ['254', 7, 10, '0'],
  KG: ['996', 9, 10, '0'],
  KH: ['855', 8, 10, '0'],
  KI: ['686', 5, 8, '0'],
  KM: ['269', 7, 7, ''],
  KN: ['1', 10, 10, '1'],
  KP: ['850', 8, 10, '0'],
  KR: ['82', 5, 14, '0'],
  KW: ['965', 7, 8, ''],
  KY: ['1', 10, 10, '1'],
  KZ: ['7', 10, 14, '8'],
  LA: ['856', 8, 10, '0'],
  LB: ['961', 7, 8, '0'],
  LC: ['1', 10, 10, '1'],
  LI: ['423', 7, 9, '0'],
  LK: ['94', 9, 9, '0'],
  LR: ['231', 7, 9, '0'],
  LS: ['266', 8, 8, ''],
  LT: ['370', 8, 8, '0'],
  LU: ['352', 4, 11, ''],
  LV: ['371', 8, 8, ''],
  LY: ['218', 9, 9, '0'],
  MA: ['212', 9, 9, '0', true],
  MC: ['377', 8, 9, '0'],
  MD: ['373', 8, 8, '0'],
  ME: ['382', 8, 9, '0'],
  MF: ['590', 9, 9, '0'],
  MG: ['261', 9, 9, '0'],
  MH: ['692', 7, 7, '1'],
  MK: ['389', 8, 8, '0'],
  ML: ['223', 8, 8, ''],
  MM: ['95', 6, 10, '0'],
  MN: ['976', 8, 10, '0'],
  MO: ['853', 7, 8, ''],
  MP: ['1', 10, 10, '1'],
  MQ: ['596', 9, 9, '0'],
  MR: ['222', 8, 8, ''],
  MS: ['1', 10, 10, '1'],
  MT: ['356', 8, 8, ''],
  MU: ['230', 7, 10, ''],
  MV: ['960', 7, 10, ''],
  MW: ['265', 7, 9, '0'],
  MX: ['52', 10, 10, ''],
  MY: ['60', 8, 10, '0'],
  MZ: ['258', 8, 9, ''],
  NA: ['264', 8, 9, '0'],
  NC: ['687', 6, 6, ''],
  NE: ['227', 8, 8, ''],
  NF: ['672', 6, 6, ''],
  NG: ['234', 10, 14, '0'],
  NI: ['505', 8, 8, ''],
  NL: ['31', 5, 11, '0'],
  NO: ['47', 5, 8, '', true],
  NP: ['977', 8, 11, '0'],
  NR: ['674', 7, 7, ''],
  NU: ['683', 4, 7, ''],
  NZ: ['64', 5, 10, '0'],
  OM: ['968', 7, 9, ''],
  PA: ['507', 7, 11, ''],
  PE: ['51', 8, 9, '0'],
  PF: ['689', 6, 9, ''],
  PG: ['675', 7, 8, ''],
  PH: ['63', 6, 13, '0'],
  PK: ['92', 8, 12, '0'],
  PL: ['48', 6, 10, ''],
  PM: ['508', 6, 9, '0'],
  PR: ['1', 10, 10, '1'],
  PS: ['970', 8, 10, '0'],
  PT: ['351', 9, 9, ''],
  PW: ['680', 7, 7, ''],
  PY: ['595', 6, 11, '0'],
  QA: ['974', 7, 11, ''],
  RE: ['262', 9, 9, '0', true],
  RO: ['40', 6, 9, '0'],
  RS: ['381', 6, 12, '0'],
  RU: ['7', 10, 14, '8', true],
  RW: ['250', 8, 9, '0'],
  SA: ['966', 9, 10, '0'],
  SB: ['677', 5, 7, ''],
  SC: ['248', 7, 7, ''],
  SD: ['249', 9, 9, '0'],
  SE: ['46', 6, 12, '0'],
  SG: ['65', 8, 11, ''],
  SH: ['290', 4, 5, '', true],
  SI: ['386', 5, 8, '0'],
  SJ: ['47', 5, 8, ''],
  SK: ['421', 6, 9, '0'],
  SL: ['232', 8, 8, '0'],
  SM: ['378', 8, 10, ''],
  SN: ['221', 9, 9, ''],
  SO: ['252', 6, 9, '0'],
  SR: ['597', 6, 7, ''],
  SS: ['211', 9, 9, '0'],
  ST: ['239', 7, 7, ''],
  SV: ['503', 7, 11, ''],
  SX: ['1', 10, 10, '1'],
  SY: ['963', 8, 9, '0'],
  SZ: ['268', 8, 9, ''],
  TA: ['290', 4, 4, ''],
  TC: ['1', 10, 10, '1'],
  TD: ['235', 8, 8, ''],
  TG: ['228', 8, 8, ''],
  TH: ['66', 8, 13, '0'],
  TJ: ['992', 9, 9, ''],
  TK: ['690', 4, 7, ''],
  TL: ['670', 7, 8, ''],
  TM: ['993', 8, 8, '8'],
  TN: ['216', 8, 8, ''],
  TO: ['676', 5, 7, ''],
  TR: ['90', 7, 13, '0'],
  TT: ['1', 10, 10, '1'],
  TV: ['688', 5, 7, ''],
  TW: ['886', 7, 11, '0'],
  TZ: ['255', 9, 9, '0'],
  UA: ['380', 9, 10, '0'],
  UG: ['256', 9, 9, '0'],
  US: ['1', 10, 10, '1', true],
  UY: ['598', 4, 13, '0'],
  UZ: ['998', 9, 9, ''],
  VA: ['39', 6, 12, ''],
  VC: ['1', 10, 10, '1'],
  VE: ['58', 10, 10, '0'],
  VG: ['1', 10, 10, '1'],
  VI: ['1', 10, 10, '1'],
  VN: ['84', 7, 10, '0'],
  VU: ['678', 5, 7, ''],
  WF: ['681', 6, 9, ''],
  WS: ['685', 5, 10, ''],
  XK: ['383', 8, 12, '0'],
  YE: ['967', 7, 9, '0'],
  YT: ['262', 9, 9, '0'],
  ZA: ['27', 5, 10, '0'],
  ZM: ['260', 9, 9, '0'],
  ZW: ['263', 7, 10, '0'],
}
